module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "avatar-container"
  }, [(_vm.comment.subPosterType === 'developer') ? _c('avatar', {
    attrs: {
      "profile-data": _vm.comment.poster,
      "profile-type": "developer",
      "size": "small",
      "show-xp-info": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.comment.subPosterType === 'game') ? _c('avatar', {
    attrs: {
      "profile-data": _vm.comment.subPoster,
      "profile-type": "game",
      "size": "small",
      "show-xp-info": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "comment-details"
  }, [(_vm.comment.subPosterType === 'developer') ? _c('span', {
    staticClass: "comment-from"
  }, [_c('router-link', {
    attrs: {
      "to": '/Developer/' + _vm.comment.poster.stringUrl
    }
  }, [_vm._v(_vm._s(_vm.comment.poster.alias))])], 1) : _vm._e(), _vm._v(" "), (_vm.comment.subPosterType === 'game') ? _c('span', {
    staticClass: "comment-from"
  }, [_c('router-link', {
    attrs: {
      "to": '/Game/' + _vm.comment.subPoster.stringUrl
    }
  }, [_vm._v(_vm._s(_vm.comment.subPoster.alias))]), _vm._v(" by\n            "), _c('router-link', {
    attrs: {
      "to": '/Developer/' + _vm.comment.poster.stringUrl
    }
  }, [_vm._v(_vm._s(_vm.comment.poster.alias))])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "comment-date"
  }, [_vm._v(_vm._s(_vm._f("formatDateCondensed")(_vm.comment.timestamp)))]), _vm._v(" "), (!_vm.editMode && !_vm.deleteMode && _vm.canEdit) ? _c('span', {
    staticClass: "comment-options"
  }, [_c('span', {
    on: {
      "click": _vm.enterEditMode
    }
  }, [_vm._v("Edit")]), _vm._v(" | "), _c('span', {
    on: {
      "click": _vm.enterDeleteMode
    }
  }, [_vm._v("Delete")])]) : _vm._e(), _vm._v(" "), (!_vm.editMode && !_vm.deleteMode) ? _c('markdown-content', {
    attrs: {
      "classes": "comment-content",
      "content": _vm.comment.content
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode && _vm.canEdit) ? _c('div', {
    staticClass: "edit-mode"
  }, [_c('markdown-editor', {
    attrs: {
      "classes": "comment-content"
    },
    model: {
      value: (_vm.editedContent),
      callback: function($$v) {
        _vm.editedContent = $$v
      },
      expression: "editedContent"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": _vm.exitEditMode
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.saveEditedComment
    }
  }, [_vm._v("Save")])], 1) : _vm._e(), _vm._v(" "), (_vm.deleteMode && _vm.canEdit) ? _c('div', {
    staticClass: "delete-mode"
  }, [_c('div', {
    staticClass: "validation-messages friendly"
  }, [_vm._v("Are you sure you want to delete this comment?")]), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": _vm.exitDeleteMode
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.deleteComment
    }
  }, [_vm._v("Delete")])]) : _vm._e(), _vm._v(" "), (!_vm.editMode && !_vm.deleteMode) ? _c('voting-widget', {
    attrs: {
      "parent-type": "post",
      "parent-id": _vm.comment.id,
      "initial-points": "0"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3897ac8f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/FeedPosts/PostComment.vue
// module id = 851
// module chunks = 2